import React, { ReactElement } from "react";
import { Badge, BadgeColor, depascalize, ensure, Stack } from "sprint-common-web";

import { AssetOperationType } from "../types/AssetOperationType";

export const renderAssetOperationType = <T extends { operationType: number }>(item?: T): ReactElement | null => {
    ensure(item);

    const operationType = item.operationType;

    const operationTypeColorMap: Record<number, number> = {
        [AssetOperationType.Ignored]: BadgeColor.Gray,
        [AssetOperationType.New]: BadgeColor.LightGreen,
        [AssetOperationType.Retained]: BadgeColor.ApplicationPrimary,
        [AssetOperationType.Overridden]: BadgeColor.Yellow
    };

    return (
        <Stack horizontalAlign="start" verticalAlign="center">
            <Badge
                testId="asset-operation-type"
                text={depascalize(AssetOperationType[operationType])}
                color={operationTypeColorMap[operationType]}
            />
        </Stack>
    );
};
